module.exports = __webpack_public_path__ + "img/inncash-background.7d62867f.webp";